import { render } from "./OurExperts.vue?vue&type=template&id=15a525af&scoped=true"
import script from "./OurExperts.vue?vue&type=script&lang=js"
export * from "./OurExperts.vue?vue&type=script&lang=js"

import "./OurExperts.vue?vue&type=style&index=0&id=15a525af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a525af"]])

export default __exports__